(($, Drupal) => {
  const initToggleMenuList = (el) => {
    const $parent = $(el);
    const menuToggler = $parent.find('.menu-list__toggler');
    const menu = $parent.find('ul');
    const heightMenu = menu.length > 0 ? menu.outerHeight() : 0;

    if (menu.length > 0) {
      menu.css({ height: 0, display: 'flex' });

      if (menu.find('a.is-active').length) {
        $parent.addClass('has-active-link');
      }
    }

    const onExpand = (e) => {
      const { target } = e;
      const { parent } = e.data;
      parent.addClass('expanded');

      $(target).attr({
        'aria-expanded': 'true',
      });

      $(target).off('transitionrun', null, onExpand);
    };

    const onCollapse = (e) => {
      const { target } = e;
      const { parent } = e.data;

      parent.removeClass('expanded');
      $(target).attr({
        'aria-expanded': 'false',
      });

      $(target).off('transitionend', null, onCollapse);
    };

    menuToggler.on('click', (e) => {
      e.preventDefault();

      const { target } = e;
      const menuId = $(target).attr('aria-controls');
      const submenu = $(`#${menuId}`);

      if ($(target).data('action').includes('expand')) {
        $(target).data('action', 'collapse-menu');
        $(target).toggleClass('collapse');

        submenu.css({ height: `${heightMenu}px` });
        submenu.on('transitionrun', { parent: $parent }, onExpand);
        return;
      }

      if ($(target).data('action').includes('collapse')) {
        $(target).data('action', 'expand-menu');
        $(target).toggleClass('collapse');

        submenu.css({ height: 0, overflow: 'hidden' });
        submenu.on('transitionend', { parent: $parent }, onCollapse);
      }
    });
  };

  let idCounter = 0;

  function generateID(prefix) {
    idCounter += 1;
    return String(prefix) + idCounter;
  }

  Drupal.behaviors.mstToggleMenuList = {
    attach: (context) => {
      const mainMenuExpandables = $('.main-menu .menu-list__item.expandable', context);
      mainMenuExpandables.each((index, el) => {
        const id = generateID('menu-list-');
        $(el).children('ul').attr('id', id);
        $(el)
          .children('.menu-list__toggler')
          .attr({ 'aria-controls': id, 'aria-haspopup': 'true' });
      });

      $('.menu-list__item.expandable', context).each((index, element) => initToggleMenuList(element));
    },
  };
})(jQuery, Drupal);
